export default "__VITE_ASSET__3481ab27__"